import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import ClientsOverviewComponent from 'webapp/components/clients/overview';
import CommonAddButtonComponent from 'webapp/components/common/add-button';
import FilterLineProxyComponent from 'webapp/components/filter/line-proxy';

import FilterSortClientInOverview from 'webapp/models-custom/filter-sort/client-in-overview';
import type { Space } from 'webapp/models-custom/index';

interface Args {
	clients: Space[];
	onAdd: () => void;
}

export default class ClientsGoalsComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;

	filterSort: FilterSortClientInOverview;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.filterSort = new FilterSortClientInOverview(
			{
				getAllItems: () => {
					return this.args.clients;
				},
			},
			true,
		);
	}

	get addButtonContainerNode() {
		return this.accountService.canAddClient
			? this.navigationService.addButtonContainerNode
			: null;
	}

	@action
	addClient(): void {
		this.args.onAdd();
	}
	<template>
		<FilterLineProxyComponent @model={{this.filterSort}} />

		<div id="clientGoals">
			<ClientsOverviewComponent
				@model={{@clients}}
				@filterSort={{this.filterSort}}
				@isGoals={{true}}
			/>
		</div>

		{{#if this.addButtonContainerNode}}
			{{#in-element this.addButtonContainerNode}}
				<CommonAddButtonComponent @text="Add account" @callTrigger={{this.addClient}} />
			{{/in-element}}
		{{/if}}
	</template>
}
